import axios, { type AxiosResponse, type InternalAxiosRequestConfig } from 'axios';
import {
    isDashboardMockupEnabled,
    resolveDashboardMockupResponse
} from '#layers/core/app/pages/account/dashboards/_runtime/mockup/dashboardMockup';

export default defineNuxtPlugin({
    name: 'dashboard-mockup',
    dependsOn: ['axios'],
    setup()
    {
        axios.interceptors.request.use((config: InternalAxiosRequestConfig) =>
        {
            if (!isDashboardMockupEnabled())
            {
                return config;
            }

            const mockData = resolveDashboardMockupResponse(config);

            if (mockData === undefined)
            {
                return config;
            }

            config.adapter = async (requestConfig) =>
            {
                const response: AxiosResponse = {
                    data: mockData,
                    status: 200,
                    statusText: 'OK',
                    headers: {
                        'content-type': 'application/json'
                    },
                    config: requestConfig,
                    request: {}
                };

                return response;
            };

            return config;
        });
    }
});
